// extracted by mini-css-extract-plugin
module.exports = {"root":"HighlightsSection_root__TZj2t","list":"HighlightsSection_list__3enKe","rotation":"HighlightsSection_rotation__dqIbl"};